import { ComponentProps } from "react";

const GoogleIcon = (props: ComponentProps<"svg">) => (
  <svg width={20} height={20} fill="none" {...props}>
    <mask
      id="prefix__a"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={19}
      height={19}
    >
      <path
        d="M18.542 8.148H10v3.463h4.917c-.459 2.2-2.375 3.463-4.917 3.463-3 0-5.417-2.363-5.417-5.296C4.583 6.844 7 4.48 10 4.48c1.292 0 2.458.449 3.375 1.182l2.667-2.607C14.417 1.67 12.333.815 10 .815 4.917.815.833 4.807.833 9.778c0 4.97 4.084 8.963 9.167 8.963 4.583 0 8.75-3.26 8.75-8.963 0-.53-.083-1.1-.208-1.63z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#prefix__a)">
      <path d="M0 15.074V4.481l7.083 5.297L0 15.074z" fill="#FBBC05" />
    </g>
    <mask
      id="prefix__b"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={19}
      height={19}
    >
      <path
        d="M18.542 8.148H10v3.463h4.917c-.459 2.2-2.375 3.463-4.917 3.463-3 0-5.417-2.363-5.417-5.296C4.583 6.844 7 4.48 10 4.48c1.292 0 2.458.449 3.375 1.182l2.667-2.607C14.417 1.67 12.333.815 10 .815 4.917.815.833 4.807.833 9.778c0 4.97 4.084 8.963 9.167 8.963 4.583 0 8.75-3.26 8.75-8.963 0-.53-.083-1.1-.208-1.63z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#prefix__b)">
      <path
        d="M0 4.481l7.083 5.297L10 7.293l10-1.59V0H0v4.481z"
        fill="#EA4335"
      />
    </g>
    <mask
      id="prefix__c"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={19}
      height={19}
    >
      <path
        d="M18.542 8.148H10v3.463h4.917c-.459 2.2-2.375 3.463-4.917 3.463-3 0-5.417-2.363-5.417-5.296C4.583 6.844 7 4.48 10 4.48c1.292 0 2.458.449 3.375 1.182l2.667-2.607C14.417 1.67 12.333.815 10 .815 4.917.815.833 4.807.833 9.778c0 4.97 4.084 8.963 9.167 8.963 4.583 0 8.75-3.26 8.75-8.963 0-.53-.083-1.1-.208-1.63z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#prefix__c)">
      <path
        d="M0 15.074l12.5-9.37 3.292.407L20 0v19.556H0v-4.482z"
        fill="#34A853"
      />
    </g>
    <mask
      id="prefix__d"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={19}
      height={19}
    >
      <path
        d="M18.542 8.148H10v3.463h4.917c-.459 2.2-2.375 3.463-4.917 3.463-3 0-5.417-2.363-5.417-5.296C4.583 6.844 7 4.48 10 4.48c1.292 0 2.458.449 3.375 1.182l2.667-2.607C14.417 1.67 12.333.815 10 .815 4.917.815.833 4.807.833 9.778c0 4.97 4.084 8.963 9.167 8.963 4.583 0 8.75-3.26 8.75-8.963 0-.53-.083-1.1-.208-1.63z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#prefix__d)">
      <path
        d="M20 19.555L7.083 9.778 5.417 8.556 20 4.48v15.074z"
        fill="#4285F4"
      />
    </g>
  </svg>
);

export default GoogleIcon;
